import React, { useState } from "react";
import {
  Alert,
  Button,
  Input,
  Modal,
  Space,
  Typography,
  message,
} from "antd";

import {
  CheckOutlined,
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "../../../crmSharedStyle.css";

const { Text, Paragraph } = Typography;

const ApiKeyRevealModal = ({
  open,
  data,
  onClose,
}) => {
  const [visible, setVisible] = useState(false);

  const apiKey =
    data?.api_key ||
    data?.key ||
    "";

  const copyKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);

      message.success("API key copied");
    } catch {
      message.error("Unable to copy API key");
    }
  };

  const handleClose = () => {
    setVisible(false);
    onClose();
  };

  return (
    <Modal
      title="API Key Generated Successfully"
      open={open}
      onCancel={handleClose}
      footer={[
        <Button
          key="done"
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleClose}
        >
          I Have Saved My Key
        </Button>,
      ]}
      closable={false}
      maskClosable={false}
      className="crm-modal-responsive"
    >
      <Alert
        type="warning"
        showIcon
        message="Copy this API key now"
        description="For security reasons, this key will only be displayed once. After closing this window, the full key cannot be retrieved again."
        style={{ marginBottom: 20 }}
      />

      <Text strong>API Key</Text>

      <Input.Group
        compact
        style={{
          display: "flex",
          marginTop: 8,
        }}
      >
        <Input
          value={apiKey}
          readOnly
          type={visible ? "text" : "password"}
          style={{ flex: 1 }}
        />

        <Button
          icon={
            visible
              ? <EyeInvisibleOutlined />
              : <EyeOutlined />
          }
          onClick={() =>
            setVisible((prev) => !prev)
          }
        />

        <Button
          icon={<CopyOutlined />}
          onClick={copyKey}
        >
          Copy
        </Button>
      </Input.Group>

      <Paragraph
        type="secondary"
        style={{ marginTop: 16, marginBottom: 0 }}
      >
        Use this key as a Bearer token in the
        Authorization header when calling the Public CRM API.
      </Paragraph>
    </Modal>
  );
};

export default ApiKeyRevealModal;